import { useState, useEffect } from 'react'

// el valor de element debe ser desde un use Ref para poder acceder a su posición
// referencia https://www.codegrepper.com/code-examples/javascript/react+how+to+get+scroll+position+value
export default function useScroll(props) {
	const { element = false, callback = false, positionTop = 120, noValidatePosition } = props

	// data
	const [scrollPosition, setPosition] = useState(0)
	const [wasActivated, setWasActivated] = useState(false)

	const elementPosition = element && element.current && element.current.offsetTop
	const difference = positionTop

	// action position
	const updatePosition = () => setPosition(window.pageYOffset)
	const activateCallback = element => {
		if (element <= scrollPosition + difference || noValidatePosition) {
			callback && callback()
			!wasActivated && setWasActivated(!wasActivated)
		}
	}

	// activation control
	useEffect(() => {
		if (!scrollPosition) return
		!wasActivated && element && activateCallback(elementPosition)
	}, [scrollPosition])

	useEffect(() => {
		window.addEventListener('scroll', updatePosition)
		updatePosition()

		return () => window.removeEventListener('scroll', updatePosition)
	}, [])

	return {
		scrollPosition
	}
}
